import {defineMessages} from 'react-intl';

export const messages = defineMessages({
    YES: {
        id: 'techDoc.priorityTreatment.option.yes',
        defaultMessage: 'Yes'
    },
    NO: {
        id: 'techDoc.priorityTreatment.option.no',
        defaultMessage: 'No'
    },
});

export default messages;
